import { Handle, Position } from "@xyflow/react";
import { Input, Button } from "antd";
import { PlusOutlined, DeleteOutlined, InteractionOutlined } from "@ant-design/icons";

const InteractiveButtonsNode = ({ data, selected, id }) => {
  const onChange = (field, value) => data.onChange?.({ ...data, [field]: value });

  const addButton = () => {
    const buttons = [...(data.buttons || [])];
    if (buttons.length >= 3) return;
    buttons.push({ id: `btn_${Date.now()}`, label: "" });
    onChange("buttons", buttons);
  };

  const updateButton = (index, field, value) => {
    const buttons = (data.buttons || []).map((b, i) => i === index ? { ...b, [field]: value } : b);
    onChange("buttons", buttons);
  };

  const removeButton = (index) => {
    const buttons = (data.buttons || []).filter((_, i) => i !== index);
    onChange("buttons", buttons);
  };

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? "#8b5cf6" : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 280,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    }}>
      <Handle type="target" position={Position.Left} style={{ background: "#8b5cf6" }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <InteractionOutlined style={{ color: "#8b5cf6", fontSize: 16 }} />
        <strong style={{ fontSize: 13 }}>Interactive Buttons</strong>
      </div>

      <label style={{ fontSize: 11, color: "#6b7280", display: "block", marginBottom: 4 }}>Message body</label>
      <Input.TextArea
        value={data.body || ""}
        onChange={(e) => onChange("body", e.target.value)}
        rows={2}
        placeholder="Ask a question..."
        style={{ fontSize: 12, marginBottom: 10 }}
      />

      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 6 }}>
        Buttons (max 3) — each has its own exit point →
      </div>

      {(data.buttons || []).map((btn, i) => (
        <div key={btn.id} style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6, position: "relative" }}>
          <Input
            value={btn.label}
            onChange={(e) => updateButton(i, "label", e.target.value)}
            placeholder={`Button ${i + 1} label`}
            size="small"
            style={{ flex: 1 }}
          />
          <Button
            size="small"
            danger
            icon={<DeleteOutlined />}
            onClick={() => removeButton(i)}
          />
          {/* Each button gets its own source handle for branching */}
          <Handle
            type="source"
            position={Position.Right}
            id={btn.id}
            style={{ background: "#8b5cf6", top: "50%", right: -14 }}
          />
        </div>
      ))}

      {(data.buttons || []).length < 3 && (
        <Button size="small" icon={<PlusOutlined />} onClick={addButton} style={{ marginTop: 4 }}>
          Add Button
        </Button>
      )}
    </div>
  );
};

export default InteractiveButtonsNode;
